import { CustomIcon } from '@app/core/types/common/custom-icon.type';

export const CUSTOM_ICONS: CustomIcon[] = [
  { iconName: 'facebook', iconPath: '/icons/redesign/facebook.svg' },
  { iconName: 'twitter', iconPath: '/icons/redesign/twitter.svg' },
  { iconName: 'linkedin', iconPath: '/icons/redesign/linkedin.svg' },
  { iconName: 'youtube', iconPath: '/icons/redesign/youtube.svg' },
  { iconName: 'instagram', iconPath: '/icons/redesign/instagram.svg' },
  { iconName: 'cart', iconPath: '/icons/redesign/cart.svg' },
  { iconName: 'arrow-down', iconPath: '/icons/redesign/arrow-down.svg' },
  { iconName: 'arrow-right', iconPath: '/icons/redesign/arrow-right.svg' },
  { iconName: 'arrow-left', iconPath: '/icons/redesign/arrow-left.svg' },
  { iconName: 'arrow-up-end', iconPath: '/icons/redesign/arrow-up-end.svg' },
  { iconName: 'add-to-cart', iconPath: '/icons/redesign/add-to-cart.svg' },
  { iconName: 'close', iconPath: '/icons/redesign/close.svg' },
  { iconName: 'filter', iconPath: '/icons/redesign/filter.svg' },
  { iconName: 'brightness-low', iconPath: '/icons/redesign/brightness-low.svg' },
  { iconName: 'settings', iconPath: '/icons/redesign/settings.svg' },
  { iconName: 'search', iconPath: '/icons/redesign/search.svg' },
  { iconName: 'visibility', iconPath: '/icons/redesign/visibility.svg' },
  { iconName: 'visibility-off', iconPath: '/icons/redesign/visibility-off.svg' },
  { iconName: 'download', iconPath: '/icons/redesign/download.svg' },
  { iconName: 'in-stock', iconPath: '/icons/redesign/in-stock.svg' },
  { iconName: 'obsolete', iconPath: '/icons/redesign/obsolete.svg' },
  { iconName: 'replenishment', iconPath: '/icons/redesign/replenishment.svg' },
  { iconName: 'plus', iconPath: '/icons/redesign/plus.svg' },
  { iconName: 'minus', iconPath: '/icons/redesign/minus.svg' },
  { iconName: 'email', iconPath: '/icons/redesign/email.svg' },
  { iconName: 'time', iconPath: '/icons/redesign/time.svg' },
  { iconName: 'info', iconPath: '/icons/redesign/info.svg' },
  { iconName: 'equalizer', iconPath: '/icons/redesign/equalizer.svg' },
  { iconName: 'quick-order', iconPath: '/icons/redesign/quick-order.svg' },
  { iconName: 'calendar', iconPath: '/icons/redesign/calendar.svg' },
  { iconName: 'delete', iconPath: '/icons/redesign/delete.svg' },
  { iconName: 'check', iconPath: '/icons/redesign/check.svg' },
  { iconName: 'alert-report', iconPath: '/icons/redesign/alert-report.svg' },
  { iconName: 'alert', iconPath: '/icons/redesign/alert.svg' },
  { iconName: 'expected-date', iconPath: '/icons/redesign/expected-date.svg' },
  { iconName: 'info-outline', iconPath: '/icons/redesign/info-outline.svg' },
  { iconName: 'help', iconPath: '/icons/redesign/help.svg' },
  { iconName: 'edit', iconPath: '/icons/redesign/edit.svg' },
  { iconName: 'help-solid', iconPath: '/icons/redesign/help-solid.svg' },
  { iconName: 'warning', iconPath: '/icons/redesign/warning.svg' },
  { iconName: 'alert-solid', iconPath: '/icons/redesign/alert-solid.svg' },
  { iconName: 'website', iconPath: '/icons/redesign/website.svg' },
  { iconName: 'location', iconPath: '/icons/redesign/location.svg' },
  { iconName: 'phone', iconPath: '/icons/redesign/phone.svg' },
  { iconName: 'fax', iconPath: '/icons/redesign/fax.svg' },
  { iconName: 'upload', iconPath: '/icons/redesign/upload.svg' },
  { iconName: 'marker', iconPath: '/icons/redesign/marker.svg' }
];
